import { Choices } from '@/components/GroupSelect';
import { createSlice } from '@reduxjs/toolkit';

export interface RegisterStep {
  email: string;
  password: string;
}

export interface FirstStep {
  name: string;
  lastName: string;
  cellPhone: string;
}

export interface SecondStep {
  companyTitle: string;
  companyType: string;
  tcknVkn: string;
  webPage: string;
  aboutCompany: string;
  serviceCats: Choices;
}

export interface FinalFormType extends RegisterStep, FirstStep, SecondStep {}

export type TotalFormDataType = {
  registerStep: RegisterStep;
  firstStep: FirstStep;
  secondStep: SecondStep;
};

// export const createPermission: any = createAsyncThunk(
//   'auth/createPermission',
//   async () => {
//     const { data:any } = await httpPost(`${CONFIG.ENDPOINTS.createPerm}`, {
//       type: 1,
//     });

//     return data;
//   }
// );

const initialState = {
  form: {
    registerStep: {
      email: '',
      password: '',
    },
    firstStep: {
      name: '',
      lastName: '',
      cellPhone: '',
    },
    secondStep: {
      companyTitle: '',
      companyType: '',
      tcknVkn: '',
      webPage: '',
      aboutCompany: '',
      serviceCats: [] as Choices,
    },
  },
  currentStep: 0,
  activeTab: 0,
  isRegistered: false,
  forgotPassword: {
    email: null as string,
    step: 0,
  },
};

export const RegistrySlice = createSlice({
  name: 'Registry',
  initialState,
  reducers: {
    fillStep: (state: any, action: any) => {
      state.form[action.payload.step] = action.payload.data;
    },
    changeStep: (state: any, action: any) => {
      state.currentStep = action.payload;
    },
    setActiveTab: (state: any, action: any) => {
      state.activeTab = action.payload;
    },
    removeForm: (state: any) => {
      state.form = initialState.form;
      state.currentStep = 0;
    },
    register: (state: any, action: any) => {
      state.isRegistered = action.payload;
    },
    changeForgotPasswordStep: (state: any, action: any) => {
      state.forgotPassword = {
        email: state.forgotPassword.email,
        step: action.payload,
      };
    },
    setForgotPasswordEmail: (state: any, action: any) => {
      state.forgotPassword = {
        email: action.payload,
        step: state.forgotPassword.step,
      };
    },
  },
  extraReducers: {},
});

export const {
  fillStep,
  changeStep,
  setActiveTab,
  removeForm,
  register,
  changeForgotPasswordStep,
  setForgotPasswordEmail,
} = RegistrySlice.actions;

export default RegistrySlice.reducer;
